import { useEffect, useState } from 'react';
import { fetchPublicFaqs, type Faq } from '@/services/faqs';

// Sección de Preguntas Frecuentes (acordeón) de la tienda pública.
// Se ubica entre el banner Hero y el catálogo de referencias.
export default function FaqSection() {
  const [faqs, setFaqs] = useState<Faq[]>([]);
  const [openId, setOpenId] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetchPublicFaqs().then((rows) => {
      if (cancelled) return;
      setFaqs(rows);
      if (rows.length > 0) setOpenId(rows[0].id);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (faqs.length === 0) return null;

  return (
    <section id="preguntas" className="py-16 md:py-20 bg-background-100 scroll-mt-16">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <span className="text-xs font-semibold text-accent-600 uppercase tracking-wider">
            Resolvemos tus dudas
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mt-3 mb-3">
            Preguntas Frecuentes
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            Todo lo que necesitas saber antes de elegir tus paticas con propósito.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq) => {
            const isOpen = openId === faq.id;
            return (
              <div
                key={faq.id}
                className="bg-white rounded-xl border border-background-200 overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => setOpenId(isOpen ? null : faq.id)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center gap-3 text-left px-5 py-4 cursor-pointer hover:bg-background-50 transition-colors"
                >
                  <span className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-question-line text-accent-600"></i>
                  </span>
                  <span className="flex-1 min-w-0">
                    <span className="block text-[11px] font-semibold text-accent-600 uppercase tracking-wide">
                      {faq.category}
                    </span>
                    <span className="block text-sm md:text-base font-medium text-foreground-900 mt-0.5">
                      {faq.question}
                    </span>
                  </span>
                  <i
                    className={`text-foreground-400 text-lg transition-transform ${
                      isOpen ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                  ></i>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 pl-16">
                    <p className="text-sm text-foreground-600 leading-relaxed whitespace-pre-wrap">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}